import Ellipse from "@/assets/style/Ellipse.svg";
import SelectLicenseHeader from "@/components/header/SelectLicenseHeader";
import UserType from "@/domain/enums/UserType";
import useGetUserProfile from "@/hooks/useGetUserProfile";
import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import LicenseSelector from "./LicenseSelector";
import LicenseTabs from "./licenseTabs";

const SelectLicense: React.FC = () => {
    const { t } = useTranslation();
    const { data: userProfile, isLoading: isUserProfileLoading } =
        useGetUserProfile();

    const location = useLocation();
    const navigationState = location.state;

    const defaultTab =
        navigationState?.defaultTab ||
        (userProfile?.userType === UserType.ENTERPRISE_USER ||
        userProfile?.userType === UserType.ENTERPRISE_MANAGER
            ? LicenseTabs.ENTERPRISE
            : LicenseTabs.PUBLIC);

    if (isUserProfileLoading) {
        return null;
    }

    return (
        <div className="text-text-main-title relative flex h-screen w-screen flex-col overflow-x-hidden">
            <SelectLicenseHeader user={userProfile!} />

            <img
                alt="Ellipse"
                className="absolute top-0 h-[400px] w-[400px] select-none md:h-[600px] md:w-[600px]"
                src={Ellipse}
            />

            <img
                alt="Ellipse"
                className="absolute -right-32 bottom-0 h-[400px] w-[400px] select-none md:h-[600px] md:w-[600px]"
                src={Ellipse}
            />

            <main className="relative flex flex-col items-center pb-6">
                <h1 className="text-center font-display text-5xl font-normal">
                    {t("license.title")}
                </h1>

                <LicenseSelector
                    className="px-15 xl:px-30"
                    defaultTab={defaultTab}
                />
            </main>
        </div>
    );
};

export default SelectLicense;
